import { createSlice } from "@reduxjs/toolkit";

export const commodity = createSlice({
  name: "commodityTabs",
  initialState: {
    currentTabs: 0, //0-commodity, 1-variety
  },

  reducers: {
    updateCurrentTabs: (state = commodity?.initialState, action) => {
      state.currentTabs = action.payload;
    },
  },
});
export const { updateCurrentTabs } = commodity.actions;
export default commodity.reducer;
